import { render } from "./ProjectLevel.vue?vue&type=template&id=7843e34e&ts=true"
import script from "./ProjectLevel.vue?vue&type=script&lang=ts"
export * from "./ProjectLevel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__